import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Toast } from 'antd-mobile';

import { location } from 'src/history';

import { getAppId } from '@utils/global';
import { ajax } from '@utils/http';
import { getQueryString, docCookies } from '@utils/tools';
import { setApp } from '@utils/app';
import { appMethod as app, appInstance } from '@utils/app';
import util from '@utils/util';

import CustomPage from './custom-page/CustomPage';
import LoadingPage from './loading-page/LoadingPage';
import CustomComponent from 'src/custom-component/CustomComponent';
import officialPageList from 'src/official-page/officialPageList';
import { GoodsShoppingCart } from 'src/common/goods-shopping-cart/GoodsShoppingCart';
import { TostoreShoppingCart } from 'src/common/tostore-shopping-cart/TostoreShoppingCart';
import { RewardPointModal } from 'src/common/reward-point-modal/RewardPointModal';
import { ShowVipModal } from 'src/common/show-vip-modal/ShowVipModal';
import { PageQrcode } from 'src/common/page-qrcode/PageQrcode';
import { Pay } from 'src/common/pay/Pay';
import { configWxSDK } from 'src/utils/weixinSdkConfig';

// import AlloyLever from 'alloylever';

// import '@mock/appdata'; // TODO：test 仅开发环境
// import '@mock/formdata'; // TODO：test 仅开发环境

/**
 * 用户页面路由数据(空数组)
 */
const customRoutes = [];
/**
 * 官方页面路由数据(所有的页面的对应路由)
 */
const officialRoutes = Object.keys(officialPageList);
/**
 * 官方页面外层包一层
 */
function wrapperOfficialPage(route, props) {
  
  // 控制台输出当前页面信息
  console.log(`【当前应用】${app.getAppId()}\n【页面路由】${route} \n【可复现路径】${window.location.href}`);
  // 是否为底部导航
  let isTabBarPage = app.globalData.tabBarPagePathArr.indexOf(route) > -1;
  // 底部导航组件
  let $tabNav = () => {
    // 当前页面设为底部导航
    if (isTabBarPage) {
      let appData = appInstance.state.appData;
      let tabBarData = appData.data['tab-bar']; // 底部导航数据
      let bottomNarData = {
        type: 'tab-nav',
        content: tabBarData.list,
        customFeature: {
          color: tabBarData.color || '#59607B',
          selectedColor: tabBarData.selectedColor || 'inherit',
          backgroundColor: tabBarData.backgroundColor || '#fff',
          borderStyle: tabBarData.borderStyle || 'black',
          position: 'bottom'
        }
      }
      return <CustomComponent {...props} data={bottomNarData}></CustomComponent>
    }
  };
  return <div className={`official-page ${route}`} style={{
    height: isTabBarPage ?  'calc(100vh - 48px)' : null
  }}>
    {
      officialPageList[route](props)
    }
    {/* 底部导航 */}
    {
      $tabNav()
    }
  </div>
}
/**
 * 设置app导航数据
 */
function setTabBarData(appData) {
  let tabBarData = appData.data['tab-bar']; // 底部导航数据
  if (!tabBarData) {
    return;
  }
  let bottomNarData = {                     // 底部导航组件
    type: 'tab-nav',
    content: tabBarData.list,
    customFeature: {
      color: tabBarData.color || '#59607B',
      selectedColor: tabBarData.selectedColor || 'inherit',
      backgroundColor: tabBarData.backgroundColor || '#fff',
      borderStyle: tabBarData.borderStyle || 'black',
      position: 'bottom'
    }
  }
  let arr = [];
  for (let item of tabBarData.list) {
    let router = item.router;
    // TODO: 还没处理完  
    if (router.indexOf('tabbar') > -1) {
      router = router.replace(/tabbar/gi, '');
      item.router = router = router.replace(router[0], router[0].toLowerCase());
    }
    if (router && appData[router]) {
      appData[router].eles.push(bottomNarData);
    }
    arr.push(router);
  }
  app.globalData.tabBarPagePathArr = arr;
}
/**
 * 判断当前AppData是否有某个组件
 */
function hasCustomComponent(appData, componentType) {
  // 当前应用数据
  let data = appData;
  // 当前组件类型
  let type = componentType;
  // 标记是否有当前组件
  let flag = false;
  const findComponent = (ele) => {
    // 已经标记为true
    if (flag) {
      return;
    }
    // 不为组件
    if (!ele.type) {
      return;
    }
    // 当前组件是否有寻找的组件，有则标记
    if (ele.type === type) {
      flag = true;
      return;
    }
    // 判断当前组件不为最后一级
    if (Array.isArray(ele.content)) {
      for (let subEle of ele.content) {
        findComponent(subEle);
        if (flag) {
          return;
        }
      }
    } else if (ele.type === 'layout-vessel') { // 双栏组件的content不为数组
      for (let attr of Object.keys(ele.content)) {
        for (let subEle of ele.content[attr]) {
          findComponent(subEle);
          if (flag) {
            return;
          }
        }
      }
    }
  }
  for (let key of Object.keys(data)) {
    if (key.includes('page') || key.includes('Page')) {
      for (let ele of data[key]['eles']) {
        findComponent(ele);
        if (flag) {
          break;
        }
      }
      if (flag) {
        break;
      }
    }
  }
  return flag;
}

export default class App extends React.Component {
  state = {
    allData: null,
    appData: null,
    loading: true,
    pathname:''
  }
  
  goodsShoppingCartRef = React.createRef();
  tostoreShoppingCartRef = React.createRef();
  pageQrcodeRef = React.createRef();
  payRef = React.createRef();
  rewardPointModalRef = React.createRef();
  showVipModalRef = React.createRef();

  constructor(props){
    super(props);
    const url = window.location.href;  // 获取当前页面 URL
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname.split('/').pop(); 
    console.log('路由路径:', pathname);
    
    let appId = getQueryString('app_id') || app.getAppId();
    // appId = 'mGM61666Ma'; // TODO: 临时测试使用，之后要删掉
    if (!appId) {
      return;
    }
    app.setAppId(appId);
    setApp(this);
    // 保存当前初始化时的参数
    app.setQueryParams();
    /**
     * 设置是否登录（微信浏览器中处理/抖音浏览器/游客登录(在预览页中嵌套)）
     */
    if (app.isWeixin()) {
      // 判断是否登录
      app.sendRequest({
        url: '/index.php?r=AppUser/LoginState',
        success: (res) => {
          if (res.data) {
            // 设置登录成功
            app.setIsLogin(true);
            // 请求用户信息
            app.requestUserInfo();
            // 绑定用户微信号信息
            app.bindUserAccount();
          }else{
            app.goLogin();
          }
        }
      })
    } else if (app.isDouyin()) {
      // 判断是否登录
      app.sendRequest({
        url: '/index.php?r=AppUser/LoginState',
        success: (res) => {
          if (res.data) {
            // 设置登录成功
            app.setIsLogin(true);
            // 请求用户信息
            app.requestUserInfo();
            // 绑定用户微信号信息
            app.bindUserAccount();
          }
        }
      })
    } else if (localStorage.getItem('is_preview') == 1 || getQueryString('is_preview')) {
      // 游客登录 去登录（在预览页中嵌套中用此登录）
      app.autoTouristLogin().then(() => {
        this.init();
      })
      return;
    }

    if(pathname !== 'tap-pay'){      
      this.init()
    }

  }
  componentDidMount(){
    const url = window.location.href;  
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname.split('/').pop(); 
    if (pathname == 'tap-pay') {
      this.setState({ loading: false });  // 否则直接更新 loading 状态
    } 
  }

  init() {
    if (app.isLogin()) {
      app.globalData.isLogin = true;
    }
    // 请求app全局数据
    ajax({
      url: '/index.php?r=AppData/detail',
      type: 'post',
      data: {
        app_id: getAppId(),
        from: getQueryString('from'),
        history_id: getQueryString('history_id'),
      },
      success: (res) => {
        if (res.status !== 0) {
          if (res.status === 3 && res.data === '应用被屏蔽') {
            window.location.href = 'https://u513199.jisuapp.cn/zc_webapp/page10000?app_id=Wp06QHZ4MW';
            return;
          }
          Toast.info(res.data);
          return;
        }
        let allData = res.data;
        if (!allData.app_data) {
          Toast.info('您的应用没有内容哦');
          return;
        }
        let appData = JSON.parse(allData.app_data);
        // 处理APP的页面，放入【自定义页面列表】
        for (let i in appData) {
          if(!appData.hasOwnProperty(i)){
            continue;
          }
          if (/page\d{5}/g.test(i) || i === 'storeSinglePage' || i === 'userCenterComponentPage') {
            customRoutes.push(appData[i]['router']);   
          }
        }
        // 设置首页
        app.globalData['homepageRouter'] = appData.data['xcx-homepage-router'] || appData.data['homepage-router'];
        // 设置历史版本
        app.globalData['historyDataId'] = allData['his_id'];
        // 设置APP名称
        app.globalData['appTitle'] = allData['app_name'];
        // 设置APP详情
        app.globalData['appDescription'] = allData['description'];
        // 设置APP的logo
        app.globalData['appLogo'] = allData['logo'];
        /**
         * 设置当前APP是否有某个组件
         */
        // 是否有多商家
        app.globalData['hasFranchiseeList'] = hasCustomComponent(appData, 'franchisee-list');
        // 是否有多商家连锁组件
        app.globalData['hasFranchiseeChain'] = hasCustomComponent(appData, 'franchisee-chain');
        /**
         * 设置app导航数据
         */
        setTabBarData(appData);
        
        /**
         * 设置当前页面栈(要在导航数据设置完之后处理)
         */
        app.globalData.currentPages = [{
          route: location.pathname.split('/')[1] || app.globalData['homepageRouter'],
          callbackData: null,
          setData: function(data) {
            if (this.callbackData) {
              this.callbackData = {...this.callbackData, ...data}
            } else {
              this.callbackData = data;
            }
          },
          clearCallbackData: function() {
            this.callbackData = null;
          }
        }];
        /**
         * 设置初始化
         */
        app.onLaunch();
        app.onShow();
        this.configSDK();
        this.setState({
          allData,
          appData,
          loading: false,
        });
        // this.setAlloyLever();
        /**
         * 初始化，发送消息, 传递给父级窗口message
         */
        // if (window.top !== window) {
        //   var data = JSON.stringify({
        //     name: 'appInit',
        //     url: window.location.href,
        //     router: location.pathname.replace('/', '') || app.globalData['homepageRouter'],
        //   })
        //   window.parent.postMessage(data, '*');
        // }
        /**
         * 接收消息
         */
        window.addEventListener("message", function(event) {
          
          try {
            if (event && event.data) {
              if (typeof event.data !== 'string') {
                return;
              }
              // 获取父级窗口message并跳转页面
              var data = JSON.parse(event.data);
              app.turnToPage(data.router);
            }
          } catch (err) {
            console.log(err)
          }
        }, false);
      },
      error: (err) => {
        console.error(err);
        Toast.info(err, 2);
      }
    });
  }


  configSDK(){
    if(app.isWeixin()){
      configWxSDK();
    }
  }

  // // 设置调试面板vConsole。一般不要调用这个，只有需要才调用。 参考 https://github.com/AlloyTeam/AlloyLever
  // setAlloyLever(){
  //   AlloyLever.config({
  //     cdn:'//s.url.cn/qqun/qun/qqweb/m/qun/confession/js/vconsole.min.js',  //vconsole的CDN地址
  //     reportUrl: "",  //错误上报地址
  //     reportPrefix: 'web',    //错误上报msg前缀，一般用于标识业务类型
  //     reportKey: 'msg',        //错误上报msg前缀的key，用户上报系统接收存储msg
  //     otherReport: {              //需要上报的其他信息
          
  //     },
  //     entry: ""          //请点击这个DOM元素6次召唤vConsole。//你可以通过AlloyLever.entry('#entry2')设置多个机关入口召唤神龙
  //   })
  // }

  render(){
    const { appData, loading } = this.state;
    const homepageRouter = app.globalData['homepageRouter'];
    if (loading) {
      return <LoadingPage />;
    }
    return (
      
      <React.Fragment>
        <Switch>
          {customRoutes.map((route) => 
            <Route key={route} path={'/'+ route} render={(props) => <CustomPage data={appData[route]} {...props} />}/>
          )}
          
          {officialRoutes.map((route) => 
            <Route key={route} path={'/'+ route}  render={(props) => wrapperOfficialPage(route, props)} />
          )}
          <Redirect exact from="/" to={homepageRouter} />
          
        </Switch>
        {/* 公共组件 */}
        <GoodsShoppingCart ref={this.goodsShoppingCartRef} />
        <TostoreShoppingCart ref={this.tostoreShoppingCartRef} />
        <PageQrcode ref={this.pageQrcodeRef} />
        <RewardPointModal ref={this.rewardPointModalRef} />
        <ShowVipModal ref={this.showVipModalRef} />
        <Pay ref={this.payRef} />
      </React.Fragment>
    )
  }
}




// WEBPACK FOOTER //
// ./src/frame/App.jsx